import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { analyticsTrack } from '../../analyticsUtils';
import { getRequest, postRequest } from '../../requestUtils';
import ProjectInvitationCustomTextbox from './ProjectInvitationCustomTextbox';
var InviteConsultant = /*#__PURE__*/function (_Component) {
  function InviteConsultant(props) {
    var _this;
    _classCallCheck(this, InviteConsultant);
    _this = _callSuper(this, InviteConsultant, [props]);
    _this.state = {
      currentPage: props.project ? 'review' : 'create',
      projects: [],
      project: props.project,
      isInvalid: false,
      customMessage: ''
    };
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    _this.handleInvite = _this.handleInvite.bind(_this);
    _this.handleUpdateCustomMessage = _this.handleUpdateCustomMessage.bind(_this);
    return _this;
  }
  _inherits(InviteConsultant, _Component);
  return _createClass(InviteConsultant, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        defaultProjectId = _this$props.defaultProjectId;
      return getRequest('/projects', {
        status: 'search'
      }, csrfToken).then(function (response) {
        var project = response.data.find(function (proj) {
          return proj.resource_id === defaultProjectId;
        });
        _this2.setState({
          projects: response.data,
          project: project ? {
            label: project.name,
            value: defaultProjectId
          } : null
        });
      });
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(project) {
      this.setState({
        project: project
      });
    }
  }, {
    key: "handleInvite",
    value: function handleInvite() {
      var _this3 = this;
      var _this$props2 = this.props,
        handleInvited = _this$props2.handleInvited,
        consultant = _this$props2.consultant,
        csrfToken = _this$props2.csrfToken,
        query = _this$props2.query;
      var _this$state = this.state,
        project = _this$state.project,
        customMessage = _this$state.customMessage;
      postRequest("/projects/".concat(project.value, "/project_invitations"), {
        consultant_resource_id: consultant.resource_id,
        query_id: query,
        custom_message: customMessage,
        request_proposal: true
      }, csrfToken).then(function () {
        analyticsTrack('Clicked on Send & Connect inside the Invite Consultant Modal', {
          location: 'Consultant Profile Page'
        });
        handleInvited(project.value);
      })["catch"](function () {
        _this3.setState({
          isInvalid: true
        });
      });
    }
  }, {
    key: "handleUpdateCustomMessage",
    value: function handleUpdateCustomMessage(customMessage) {
      this.setState({
        customMessage: customMessage
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        consultant = _this$props3.consultant,
        goToQuestions = _this$props3.goToQuestions,
        defaultProjectId = _this$props3.defaultProjectId;
      var _this$state2 = this.state,
        projects = _this$state2.projects,
        project = _this$state2.project,
        isInvalid = _this$state2.isInvalid,
        customMessage = _this$state2.customMessage;
      var defaultProject = projects.filter(function (p) {
        return p.resource_id === defaultProjectId;
      }).map(function (p) {
        return {
          value: p.resource_id,
          label: p.name
        };
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "invite-consultant"
      }, /*#__PURE__*/React.createElement("div", {
        className: "consultant-detail"
      }, /*#__PURE__*/React.createElement("div", {
        className: "init-icon"
      }, /*#__PURE__*/React.createElement("span", {
        className: "icon-initials"
      }, consultant.initials)), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight invite-heading"
      }, "Tell ".concat(consultant.first_name, " about your project and who you\u2019re looking for."))), /*#__PURE__*/React.createElement("div", {
        className: "invite-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group mb-8"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "project"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight"
      }, "Select an existing project:")), /*#__PURE__*/React.createElement(Select, {
        id: "project",
        className: "body-text-2",
        classNamePrefix: "select-project",
        placeholder: "Select or type...",
        options: projects.map(function (p) {
          return {
            value: p.resource_id,
            label: p.name
          };
        }),
        value: project || defaultProject,
        onChange: function onChange(option) {
          _this4.handleSelectChange(option);
          analyticsTrack('Clicked on a project inside the Invite Consultant Modal', {
            location: 'Consultant Profile Page'
          });
        }
      })), isInvalid && /*#__PURE__*/React.createElement("div", {
        className: "error-message"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), "This project was already sent to", ' ', consultant.name), /*#__PURE__*/React.createElement("div", {
        className: "mt-3 mb-12"
      }, "or"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary-no-border create-new-project",
        onClick: function onClick() {
          analyticsTrack('Clicked on Create a new project inside the Invite Consultant Modal', {
            location: 'Consultant Profile Page'
          });
          goToQuestions();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }), "Create a new project"), project && /*#__PURE__*/React.createElement(ProjectInvitationCustomTextbox, {
        consultantFirstName: consultant.first_name,
        updateParentMessage: this.handleUpdateCustomMessage,
        customMessage: customMessage
      }), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary standard-button review-and-send mt-4",
        onClick: function onClick() {
          return _this4.handleInvite();
        },
        disabled: project === null
      }, "Send & Connect!"))));
    }
  }]);
}(Component);
InviteConsultant.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  project: PropTypes.shape({}),
  goToQuestions: PropTypes.func.isRequired,
  handleInvited: PropTypes.func.isRequired,
  csrfToken: PropTypes.string.isRequired,
  query: PropTypes.number,
  defaultProjectId: PropTypes.string
};
InviteConsultant.defaultProps = {
  project: null,
  query: null,
  defaultProjectId: null
};
export default InviteConsultant;